import { DropdownSelect, InputOption, OptionGroup } from "@avenueops/web-components";
import { DynamicStatus } from "@prisma/client";
import _ from "lodash";
import React from "react";
import Skeleton from "react-loading-skeleton";
import { useSetStatusMutation } from "utils/state/processes";
import { trpc, trpc2 } from "utils/trpc";

interface Props {
  processId: string;
  status: Pick<DynamicStatus, "id" | "color" | "label"> | DynamicStatus;
  workflowId: string;
  size?: "SMALL" | "MEDIUM" | "LARGE";
  type?: "DEFAULT" | "BUTTON";
}

export default function StatusDropdown({ processId, status, workflowId, size, type = "DEFAULT" }: Props) {
  const { isLoading: statusesLoading, data: statuses } = trpc2.v2.dynamicStatus.list.useQuery();

  const { mutateAsync, isLoading } = useSetStatusMutation();

  // Sort by having Open first, terminalState last and everything else in the middle
  const compareStatus = (status1: DynamicStatus, status2: DynamicStatus) => {
    const score1: number = status1.label === "Open" ? 0 : status1.terminalState ? 1 : 0.5;
    const score2: number = status1.label === "Open" ? 0 : status2.terminalState ? 1 : 0.5;
    return score1 - score2;
  };

  const options =
    statuses
      ?.sort((a: DynamicStatus, b: DynamicStatus) => compareStatus(a, b))
      .map((status: DynamicStatus) => ({
        label: status.label,
        value: status.id,
        icon: <div className="rounded-full h-4 w-4" style={{ backgroundColor: status.color }}></div>,
      })) ?? [];

  return isLoading || statusesLoading ? (
    <div className="bg-white border shadow w-32 p-1">
      <Skeleton count={1} className="text-2xl" />
    </div>
  ) : (
    <DropdownSelect
      name={`StatusId${processId}`}
      options={options}
      selectedValue={status.id}
      size={size}
      disableUnselect
      onChange={(value: string | undefined) => {
        if (value) {
          mutateAsync({ processId: processId, statusId: value });
        }
      }}
      type={type}
    />
  );
}
